import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Tooltip from 'src/Components/Tooltip';
import { TooltipPosition } from 'src/Components/Tooltip/types';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import thetaGem from 'assets/img/thetan_gem_V2.png';
import { formatCurrency } from '@wolffun/system-currency';

const Deposit = ({
  totalPrice,
  thgPerHero
}) => {
  const renderTooltipDeposit = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltip, styles.tooltipDeposit)
    }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, formatCurrency(thgPerHero, {
      withCurrency: true,
      trimWholeFraction: true
    }), "\xA0requires 1 NFT Hero to stake"), /*#__PURE__*/React.createElement("li", null, "Please make sure the number is accurate")));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Deposit"), /*#__PURE__*/React.createElement(Tooltip, {
    content: renderTooltipDeposit(),
    position: TooltipPosition.BOTTOM,
    color: "#3C32AF"
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.icInfo
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, formatCurrency(totalPrice, {
    withCurrency: true,
    trimWholeFraction: true
  })), /*#__PURE__*/React.createElement("img", {
    src: thetaGem,
    className: styles.thetanGem
  })));
};

export default Deposit;